import { render, staticRenderFns } from "./Choices.vue?vue&type=template&id=58f3d3de&scoped=true"
import script from "./Choices.vue?vue&type=script&lang=js"
export * from "./Choices.vue?vue&type=script&lang=js"
import style0 from "./Choices.vue?vue&type=style&index=0&id=58f3d3de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f3d3de",
  null
  
)

export default component.exports